import script from "./ImageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=7317b34c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7317b34c"]])

export default __exports__